export default "__VITE_ASSET__B7vJg_jd__"